export default class PersonalityValidator {
    static isAnswerCorrect(answer) {
        return true
    }
}

